
















import { Vue, Watch, Component } from 'vue-property-decorator'
import Banner from '@/components/Banner.vue'
import TabList from '@/components/TabList.vue'

@Component({
  components: {
    Banner,
    TabList
  }
})
export default class ProductService extends Vue {
  // activeText = '全球说'
  tabList = [
    { id: 0, name: 'talkmate', text: '全球说APP', path: 'talkmate' },
    // { id: 1, name: 'childrenCourse', text: '儿童多语言启蒙', path: 'children-course' },
    // { id: 2, name: 'proCourse', text: '多语课程PRO', path: 'pro-course' },
    // { id: 3, name: 'childrenClass', text: '儿童多语实验班', path: 'children-class' },
    { id: 4, name: 'translation', text: '翻译服务', path: 'translation' },
    // { id: 4, name: 'partner', text: '合作伙伴', path: 'partner' },
    { id: 5, name: 'WebResource', text: '服务平台', path: 'web-resource' },
    { id: 6, name: 'download', text: '下载中心', path: 'download' }

  ]
  // navigation = {
  //   text: '产品与服务',
  //   path: '/product-service'
  // }
  // tabShowPage (data:string) {
  //   this.activeText = data
  // }
  navigation = [
    {
      text: '首页',
      path: '/'
    },
    {
      text: '产品与服务',
      path: '/product-service'
    },
    {
      text: '全球说APP',
      path: ''
    }
  ]
  created () {
    this.changeRoute()
  }
  @Watch('$route')
  onRouteChanged () {
    this.changeRoute()
  }
  changeRoute () {
    this.navigation.forEach((item:any, index:number) => {
      console.log('item', item)
      if (item.path === '') {
        item.text = this.$route.query.type ? this.$route.query.type : '全球说'
      }
    })
  }
}
